import axiosInstance from "../utils/axios";
import { RoadProblemReport } from "../utils/support";

export interface SupportRequest {
  name?: string;
  email: string;
  message: string;
  /** Honeypot. Left empty by anyone who can see the form. */
  website?: string;
  roadProblem?: RoadProblemReport;
}

/**
 * Sends a support request without an account.
 *
 * `axiosInstance` is safe before login: it attaches a token only when one
 * exists, and its 401 handler redirects only for an expired JWT. `signUp` and
 * `resetPassword` already post publicly through it.
 */
export const sendSupportRequest = async (request: SupportRequest) => {
  const response = await axiosInstance.post("/support/contact", request);
  return response.data;
};
